<template>
    <main>
        <section :class="pageHeaderSetting === 1 ? 'top' : 'top1' " class="card">
            <header class="f16">
                <span class="active">
                    <span class="hd">1</span>
                    <span class="title">身份证信息录入</span>
                </span>
                <span>
                    <span class="hd">2</span>
                    <span class="title">人脸核验</span>
                </span>
            </header>
            <section v-if="supervise_id_card_num_input_method=='input'" class="idcard">
                <div class="inputCard">
                    <van-form
                        ref="validateForm"
                        validate-first
                        input-align="right"
                        :show-error="false"
                        :show-error-message="false"
                    >
                        <van-field
                            required
                            rows="1"
                            autosize
                            type="textarea"
                            v-model.trim="userInfo.name"
                            label="姓名"
                            placeholder="请输入姓名"
                            :rules="[{ required: true, message: '请输入姓名' }]"
                        />
                        <van-field
                            required
                            rows="1"
                            autosize
                            maxlength=18
                            type="textarea"
                            v-model.trim="userInfo.idCardNo"
                            label="身份证号"
                            placeholder="请输入身份证号"
                            :rules="[{ required: true, message: '请输入身份证号' }]"
                        />


                    </van-form>
                </div>

            </section>
            <section v-else class="idcard">
                <article>
                    <div>
                        <figure class="front">
                            <div class="frame">
                                <div class="a"></div>
                                <div class="b"></div>
                            </div>
                            <img ref="frontImg"  />
                            <span class="posi" v-if="showCameraFront">
                                <svg-icon icon-class="idcard-upload" class-name="idcard-upload"></svg-icon>
                            </span>
                            <input type="file" @change="readFile($event, $refs.frontImg)" accept="image/*" />
                        </figure>
                        <span role="msg">{{ msgFront }}</span>
                    </div>
                </article>
                <article>
                    <div>
                        <figure class="back">
                            <div class="frame">
                                <div class="a"></div>
                                <div class="b"></div>
                            </div>
                            <img ref="backImg" />
                            <span class="posi" v-if="showCameraBack">
                                <svg-icon icon-class="idcard-upload" class-name="idcard-upload"></svg-icon>
                            </span>
                            <input type="file" @change="readFile($event, $refs.backImg)" accept="image/*" />
                        </figure>
                        <span role="msg">{{ msgBack }}</span>
                    </div>
                </article>
            </section>
            <section v-if="supervise_id_card_num_input_method!=='input'" class="note">
                <figure>
                    <img src="../../../assets/images/account/miss_card.png" />
                    <div>边框缺失</div>
                </figure>
                <figure>
                    <img src="../../../assets/images/account/blur_card.png" />
                    <div>照片模糊</div>
                </figure>
                <figure>
                    <img src="../../../assets/images/account/light_card.png" />
                    <div>闪光强烈</div>
                </figure>
            </section>
            <footer>

                <van-button
                    @click="nextStep()"
                    :disabled="!enableNext"
                    type="info">
                    下一步
                </van-button>

            </footer>
        </section>
    </main>
</template>

<script>
import Vue from 'vue';
import API from "@wd/lowcode-h5/plugin/libs/axios";
import URLTest from '@wd/lowcode-h5/plugin/config/url'
import { reduceImg } from '../libs/index';
import { Toast } from 'vant';
import store from "../../../store";
export default {
    name: 'idcard',
    data() {
        return {
            pageHeaderSetting: null,
            enableNext: false,
            msgFront: '请上传身份证正面',
            msgBack: '请上传身份证背面',
            showCameraFront: true,
            showCameraBack: true,
            isMicroMessage: true,
            userInfo: {
                name: "",
                idCardNo: "",
            },
        }
    },

    beforeDestroy() {
        Toast.clear();
    },
    computed: {
        supervise_id_card_num_input_method() {
            let supervise_id_card_num_input_method = this.$store.state.dynamic.frontendConfig.find((item) => item.key === 'supervise_id_card_num_input_method')
            if (supervise_id_card_num_input_method) {
                if (supervise_id_card_num_input_method.value) {
                    return supervise_id_card_num_input_method.value
                }else {
                    return ''
                }
            }
            return ''
        },

    },
    created() {
        this.initTemp()
    },
    watch:{
        userInfo:{
            handler(n) {
                console.log(n,'valvalval')
                if(n.idCardNo&&n.name){
                    this.enableNext =true;
                }else {
                    this.enableNext =false;
                }
            },
            deep: true
        }
    },

    mounted() {
        // this.$refs.validateForm.validate()
    },
    methods: {
        initTemp () {
            // this.pageHeaderSetting = +localStorage.getItem('pageHeaderSetting');
            this.getLayoutSetting()
        },
        getLayoutSetting() {
            let cmsData = JSON.parse(localStorage.getItem('setTempConfigs')) || null;
            this.pageHeaderSetting = cmsData && cmsData.pageHeaderSetting;
        },
        readFile(event, carImg) {
            const file = event.target.files[0];
            reduceImg(file, (base64ImgData) => {
                carImg.src = base64ImgData;
                this.showCameraFront = !this.$refs.frontImg.src;
                this.showCameraBack = !this.$refs.backImg.src;
                this.enableNext = this.$refs.frontImg.src && this.$refs.backImg.src;
            });
        },

        nextStep() {
            if(this.supervise_id_card_num_input_method=='input'){
                if(!this.userInfo.name){
                    this.$notify({
                        type: 'warning',
                        message: '请输入姓名',
                    })
                    return;
                }

                if(!this.userInfo.idCardNo){
                    this.$notify({
                        type: 'warning',
                        message: '请输入身份证号',
                    })
                    return;
                }


                Toast.loading({
                    duration: 0,
                    forbidClick: true,
                    className: 'loading',
                    loadingType: 'spinner',
                    message: '提交中',
                });

                this.$api.face.idcardDiscernNew({
                    data: {
                        name: this.userInfo.name.replace(/\s*/g,""),
                        idcardNumber: this.userInfo.idCardNo.replace(/\s*/g,""),
                    }
                }).then((res) => {
                    Toast.clear();
                    if (res.success) {
                        this.$router.push({
                            path: '/idcardconfirm',
                            query: {
                                name: this.userInfo.name,
                                idcard: this.userInfo.idCardNo,
                                courseId: this.$route.query.courseId,
                                trainId: this.$route.query.trainId || '',
                                studyProcess:this.$route.query.studyProcess,
                                backType: this.$route.query.backType,
                                trainItemExamId: this.$route.query.trainItemExamId,
                                type: this.$route.query.type,
                                contentId: this.$route.query.contentId,
                                id: this.$route.query.id,
                                refId: this.$route.query.refId,
                                refType: this.$route.query.refType,
                                respondlink: this.$route.query.respondlink,
                            }
                        });
                    }
                }).catch((err) => {
                    this.$notify({
                        duration: 3000,
                        type: 'danger',
                        message: '网络请求失败:' + err
                    });
                    console.debug(err);
                    Toast.clear();
                });







                console.log('处理+++++++')
                return
            }
            const frontBase64 = this.$refs.frontImg.src;
            const backBase64 = this.$refs.backImg.src;

            Toast.loading({
                duration: 0,
                forbidClick: true,
                className: 'loading',
                loadingType: 'spinner',
                message: '提交中',
            });
            this.$api.face.idcardDiscern({
                data: {
                    front: frontBase64.substring(frontBase64.indexOf('base64,') + 7),
                    back: backBase64.substring(backBase64.indexOf('base64,') + 7),
                }
            }).then((res) => {
                Toast.clear();
                if (res.success) {
                    this.$router.push({
                        path: '/idcardconfirm',
                        query: {
                            name: res.data.name,
                            idcard: res.data.idcardNumber,
                            courseId: this.$route.query.courseId,
                            trainId: this.$route.query.trainId || '',
                            studyProcess:this.$route.query.studyProcess,
                            backType: this.$route.query.backType,
                            trainItemExamId: this.$route.query.trainItemExamId,
                            type: this.$route.query.type,
                            contentId: this.$route.query.contentId,
                            id: this.$route.query.id,
                            refId: this.$route.query.refId,
                            refType: this.$route.query.refType,
                            respondlink: this.$route.query.respondlink,
                        }
                    });
                }
                // else {
                //     this.$notify({
                //         duration: 6000,
                //         type: 'danger',
                //         message: res.message
                //     });
                // }
            }).catch((err) => {
                this.$notify({
                        duration: 3000,
                        type: 'danger',
                        message: '网络请求失败:' + err
                    });
                console.debug(err);
                Toast.clear();
            });
        }
    }
}
</script>
<style scoped>
    .p16 {
        font-size: 32px;
    }
    .p14 {
        font-size: 28px;
    }
    .p12 {
        font-size: 24px;
    }

    main * {
        position: relative;
    }

    main {
        -webkit-touch-callout: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        -khtml-user-select: none;
        user-select: none;
        display: flex;
        flex-direction: column;
        background: #F7F7F7;
        align-items: center;
        height: 100vh;
    }

    main > section.card {
        display: flex;
        flex-direction: column;
        border-radius: 20px;
        background: white;
        align-items: center;
        position: absolute;
        /* top: 88px; */
        left: 28px;
        right: 28px;
    }
    .top{
        top: 116px;
    }
    .top1{
        top: 28px;
    }
    img[src=""], img:not([src]){
        opacity:0;
    }

    header {
        width: 100%;
        display: flex;
        justify-content: space-around;
        text-align: center;
        margin: 30px 0px;
    }

    header > span {
        display: inline-block;
        color: #737386;
        line-height: 50px;
    }

    header > span > span.hd {
        background-color: #d7dfff;
        color: white;
        text-align: center;
        display: inline-block;
        border-radius: 24px;
        width: 50px;
        height: 50px;
        margin: 0px 10px;
        line-height: 50px;
    }

    header > span.active {
        color: #3660FF;
    }

    header > span.active:after {
        content: '';
        border-top: solid 1px rgba(54, 96, 255, 0.4);
        position: absolute;
        top: 25px;
        right: -70px;
        width: 60px;
        height: 1px;
    }

    header > span.active > span.hd {
        background-color: #3660ff;
    }

    header > span > span.title {
        line-height: 50px;
        top: 2px;
    }

    section.idcard {
        margin: 15px 0;
    }

    section.idcard > article > div {
        width: 400px;
        text-align: center;
        color: #202124;
        font-size: 28px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    section.idcard > article > div > figure {
        width: 360px;
    }

    section.idcard > article > div > span {
        margin: 20px 0px;
        display: inline-block;
    }

    section.idcard > article > div > figure {
        background-size: 100% 100%;
        background-repeat: no-repeat;
        height: 240px;
    }

    section.idcard > article > div > figure > input[type=file] {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        opacity: 0;
    }

    section.idcard > article > div > figure.front {
        background-image: url('../../../assets/images/account/front_card.png');
    }

    section.idcard > article > div > figure.back {
        background-image: url('../../../assets/images/account/back_card.png');
    }


    section.idcard > article > div > figure > span.posi {
        position: absolute;
        width: 112px;
        height: 112px;
        left: 50%;
        top: 50%;
        margin-left: -56px;
        margin-top: -56px;
    }
    section.idcard > article > div > figure > span.posi .idcard-upload{
        font-size: 112px;
    }

    section.idcard > article > div > figure > img {
        width: 100%;
        height: 100%;
        border-width: 0px;
        border-radius: 12px;
    }

    section.note {
        display: flex;
        justify-content: space-around;
        font-size: 28px;
        color: #737386;
        width: 100%;
        margin: 15px 0px;
    }

    section.note > figure {
        flex: 1;
        text-align: center;
    }

    footer {
        margin: 20px 0px 48px 0px;
        width: 100%;
        text-align: center;
    }

    .frame {
        position: absolute;
        top: -6px;
        left: -6px;
        right: -6px;
        bottom: -6px;
        border: 6px #9AAFFF solid;
        border-radius: 16px;
    }

    .frame > .a {
        position: absolute;
        left: -10px;
        top: 40px;
        right: -10px;
        bottom: 40px;
        border-left: 10px white solid;
        border-right: 10px white solid;
    }

    .frame > .b {
        position: absolute;
        left: 40px;
        top: -10px;
        right: 40px;
        bottom: -10px;
        border-top: 12px white solid;
        border-bottom: 12px white solid;
    }

    footer > .van-button {
        width: 92%;
        font-size: 18px;
        border-radius: 22px;
    }

    .idcard span[role=msg] {
        color: #202124
    }

</style>
